import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { WebConfigService } from '../web-config/web-config.service';

export interface PasskeyCreationOptionsResponse {
  publicKeyCredentialCreationOptions: PublicKeyCredentialCreationOptions;
}

export interface PasskeyOptionsResponse {
  publicKeyCredentialRequestOptions: PublicKeyCredentialRequestOptions;
  username?: string;
}

@Service()
export class PasskeyService {
  #http = inject(HttpClient);
  #webConfig = inject(WebConfigService);

  // --- REGISTRATION METHODS ---
  getRegisterOptions(email: string, displayName?: string): Observable<PasskeyCreationOptionsResponse> {
    const url = `${this.#webConfig.baseUrls.backend}/auth/passkey/register`;
    return this.#http.post<PasskeyCreationOptionsResponse>(url, { email, displayName });
  }

  verifyRegistration(email: string, attestation: unknown): Observable<unknown> {
    const url = `${this.#webConfig.baseUrls.backend}/auth/passkey/register/verify`;
    return this.#http.post<unknown>(url, { email, attestation });
  }

  // --- LOGIN METHODS ---
  getLoginOptions(email: string): Observable<PasskeyOptionsResponse> {
    const url = `${this.#webConfig.baseUrls.backend}/auth/passkey`;
    return this.#http.post<PasskeyOptionsResponse>(url, { email });
  }

  verifyAssertion(email: string, assertion: unknown): Observable<unknown> {
    const url = `${this.#webConfig.baseUrls.backend}/auth/passkey/verify`;
    return this.#http.post<unknown>(url, { email, assertion });
  }

  sendMagicLink(email: string): Observable<unknown> {
    const url = `${this.#webConfig.baseUrls.backend}/auth/passkey/magic-link`;
    return this.#http.post<unknown>(url, { email });
  }

  // --- ENCODING / DECODING UTILITIES ---
  base64urlToUint8Array(base64url: string): Uint8Array<ArrayBuffer> {
    const padding = '='.repeat((4 - (base64url.length % 4)) % 4);
    const base64 = (base64url + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  bufferToBase64url(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const base64 = window.btoa(binary);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
}
